<template>
  <div
    class="html_relayMoment"
    ref="html_relayMoment"
    v-if="datas.objectInfo && datas.objectInfo.length > 0"
  >
    <div class="main">
      <span class="teamInfor" v-if="combatTeamScore.length > 0">
        <span class="teamLogo">
          <img :src="combatTeamScore[0].teamLogo" />
        </span>
        <span class="teamName" v-text="combatTeamScore[0].teamName"></span>
      </span>
      <span class="dataList">
        <span
          class="dataList_item"
          v-for="row in rowDataList"
          :key="row.totalTime2String"
        >
          <span class="barData_area" v-if="!row.isNotData">
            <span
              class="barDataArea_textArr"
              :style="{
                width: `${row.widthPer}%`,
              }"
            >
              <span
                class=""
                v-for="(rowText, rowIndex) in row.stageTimeStringArr"
                :key="rowIndex"
                v-text="rowText"
                :style="{
                  width: `${row.stageTimeWidthArr[rowIndex]}%`,
                }"
              ></span>
            </span>
            <span
              class="barDataArea_bar"
              :style="{
                width: `${row.widthPer}%`,
                backgroundImage: `linear-gradient(
              to right,
              var(--mixtmt_theme_defaultGradient_1_1) ${row.stageTimePerArr[0]}%,
              var(--mixtmt_theme_defaultGradient_1_1) ${row.stageTimePerArr[1]}%,
              var(--mixtmt_theme_defaultGradient_1_2) ${row.stageTimePerArr[2]}%,
              var(--mixtmt_theme_defaultGradient_1_2) ${row.stageTimePerArr[3]}%,
              var(--mixtmt_theme_defaultGradient_1_1) ${row.stageTimePerArr[4]}%,
              var(--mixtmt_theme_defaultGradient_1_1) ${row.stageTimePerArr[5]}%,
              var(--mixtmt_theme_defaultGradient_1_2) ${row.stageTimePerArr[6]}%,
              var(--mixtmt_theme_defaultGradient_1_2) ${row.stageTimePerArr[7]}%
            )`,
              }"
            ></span>
          </span>
          <span class="notData_bar" v-if="row.isNotData"></span>
          <span class="timeData_area" v-text="row.totalTime2String"></span>
        </span>
      </span>
      <span class="teamInfor" v-if="combatTeamScore.length > 1">
        <span class="teamLogo">
          <img :src="combatTeamScore[1].teamLogo" />
        </span>
        <span class="teamName" v-text="combatTeamScore[1].teamName"></span>
      </span>
    </div>
  </div>
</template>

<script>
// 接力时刻 团体  游泳 4*100接力等
// import htmlDomToImage_base64_data_mixin from '@mixins/htmlDomToImage_base64_data'
export default {
  name: 'html_relayMoment',
  // mixins: [htmlDomToImage_base64_data_mixin],
  components: {},
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
  },
  data() {
    return {
      //   rowData: [
      //     {
      //       stageTimeStringArr: ['56.05', '55.02', '54.68', '53.26'], //每个阶段的时间
      //       stageTimeWidthArr: [25.59 - 0, 50.71 - 25.59, 75.68 - 50.71, 100 - 75.68], //每个阶段的占比
      //       stageTimePerArr: [0, 25.59, 26, 50.71, 51, 75.68, 76, 100], //给bar上颜色用的
      //       totalTime2Sec: 219.01, // 总时间 单位: 秒
      //       totalTime2String: '3:39.01', //展示时间 分：秒
      //       widthPer: 100, //俩个队对比之后最大的为100
      //     },
      //     {
      //       stageTimeStringArr: ['36.50', '31.21', '58.15', '29.27'],
      //       stageTimeWidthArr: [
      //         23.3 - 0,
      //         43.48 - 23.3,
      //         81.07 - 43.48,
      //         100 - 81.07,
      //       ],
      //       stageTimePerArr: [0, 23.3, 24, 43.48, 44, 81.07, 82, 100],
      //       totalTime2Sec: 154.68,
      //       totalTime2String: '2:34.68',
      //       widthPer: 70.63, 小的一只队伍占比   154.68/219.01
      //     },
      //   ],
    }
  },
  created() {
    // 模拟数据
    console.debug(this.datas)
  },
  updated() {
    console.debug(`更新： ${this.datas}`)
  },
  computed: {
    rowDataList() {
      let rowDataArr = []
      let maxTimeArr = []
      console.debug('rowDataArr:', this.datas)
      if (this.datas.data && this.datas.data.dataList.length > 0) {
        // const keyArr = ['leftDataList', 'rightDataList']
        this.datas.data.dataList.forEach((itemData) => {
          console.debug('rowDataArr:', itemData)
          if (itemData) {
            let stageTimeStringArr = [],
              stageTimeWidthArr = [],
              stageTimePerArr = [],
              totalTime2Sec = 0,
              totalTime2String = ''

            itemData.forEach((item) => {
              let athleteResultValueNum = 0
              if (item.athleteResultValue.indexOf(':') > -1) {
                let timeArr = item.athleteResultValue.split(':')
                athleteResultValueNum = timeArr[0] * 60 + Number(timeArr[1])
              } else {
                athleteResultValueNum = Number(item.athleteResultValue)
              }
              stageTimeStringArr.push(item.athleteResultValue)
              totalTime2Sec += Number(athleteResultValueNum)
              if (!totalTime2String) {
                totalTime2String = item.resultValue
              }
            })
            totalTime2Sec = Number(totalTime2Sec.toFixed(2))
            maxTimeArr.push(totalTime2Sec)
            stageTimePerArr.push(0)
            let curTime2Sec = 0
            stageTimeStringArr.forEach((item, index) => {
              if (index < stageTimeStringArr.length - 1) {
                let athleteResultValueNum = 0
                if (item.indexOf(':') > -1) {
                  let timeArr = item.split(':')
                  athleteResultValueNum = timeArr[0] * 60 + Number(timeArr[1])
                } else {
                  athleteResultValueNum = Number(item)
                }
                curTime2Sec += Number(athleteResultValueNum)
                let curPer = (curTime2Sec / totalTime2Sec).toFixed(4) * 100
                stageTimePerArr.push(curPer.toFixed(2) * 1)
                stageTimePerArr.push((curPer + 1).toFixed(2) * 1)
              } else {
                // 最后一个默认100
                stageTimePerArr.push(100)
              }
            })
            if (stageTimePerArr.length === 8) {
              stageTimeWidthArr.push(stageTimePerArr[1])
              stageTimeWidthArr.push(
                (stageTimePerArr[3] - stageTimePerArr[1]).toFixed(2)
              )
              stageTimeWidthArr.push(
                (stageTimePerArr[5] - stageTimePerArr[3]).toFixed(2)
              )
              stageTimeWidthArr.push(
                (stageTimePerArr[7] - stageTimePerArr[5]).toFixed(2)
              )
            }

            rowDataArr.push({
              stageTimeStringArr,
              stageTimeWidthArr,
              stageTimePerArr,
              totalTime2Sec,
              totalTime2String,
              widthPer: 0,
              isNotData: false,
            })
          } else {
            maxTimeArr.push(0)
            rowDataArr.push({
              stageTimeStringArr: [],
              stageTimeWidthArr: [],
              stageTimePerArr: [],
              totalTime2Sec: 0,
              totalTime2String: '0',
              widthPer: 100,
              isNotData: true,
            })
          }
        })
        console.debug('rowDataArr:', maxTimeArr, rowDataArr)
        if (maxTimeArr.length === 2) {
          if (maxTimeArr[0] > maxTimeArr[1]) {
            rowDataArr[0].widthPer = 100
            rowDataArr[1].widthPer =
              (maxTimeArr[1] / maxTimeArr[0]).toFixed(4) * 100
          } else if (maxTimeArr[0] < maxTimeArr[1]) {
            rowDataArr[1].widthPer = 100
            rowDataArr[0].widthPer =
              (maxTimeArr[0] / maxTimeArr[1]).toFixed(4) * 100
          } else {
            rowDataArr[0].widthPer = 100
            rowDataArr[1].widthPer = 100
          }
        } else if (maxTimeArr.length === 1) {
          rowDataArr[0].widthPer = 100
        }
      }
      console.debug('rowDataArr:', rowDataArr)
      return rowDataArr
    },
    combatTeamScore() {
      return this.datas && this.datas.objectInfo ? this.datas.objectInfo : []
    },
  },
  methods: {
    _valFormatHandler(val, text, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (text) {
          data = `${text}: ${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.html_relayMoment {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  .main {
    width: 90%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
    color: var(--mixtmt_greyColor_main);

    .teamInfor {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      .teamLogo {
        width: 3.33vw;
        height: 2.22vw;
        overflow: hidden;
        border: 1px solid var(--mixtmt_greyColor5);
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .teamName {
        width: calc(100% - 3.33vw);
        padding: 0 0.694vw;
        height: 1.388vw;
        line-height: 1.388vw;
        font-size: 1.11vw;
        text-align: left;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        color: var(--mixtmt_greyColor3);
        font-weight: bold;
      }
    }
    .dataList {
      width: 100%;
      padding: 1.388vw 0;
      .dataList_item {
        position: relative;
        width: 100%;
        height: 2.788vw;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 1.388vw;
        &:last-child {
          margin-bottom: 0;
        }
        .barData_area {
          width: calc(100% - 5.55vw);
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;
          .barDataArea_textArr {
            padding-bottom: 0.347vw;
            width: 100%;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            color: var(--mixtmt_greyColor6);
            span {
              font-size: 0.972vw;
              line-height: 1.11vw;
              text-align: left;
            }
          }
          .barDataArea_bar {
            width: 0;
            transition: width 0.3s linear;
            height: 0.694vw;
            /* background-image: linear-gradient(
              to right,
              rgba(80, 183, 123, 1) 0%,
              rgba(80, 183, 123, 1) 25%,
              rgba(76, 159, 237, 1) 26%,
              rgba(76, 159, 237, 1) 50%,
              rgba(80, 183, 123, 1) 51%,
              rgba(80, 183, 123, 1) 75%,
              rgba(76, 159, 237, 1) 76%,
              rgba(76, 159, 237, 1) 100%
            ); */
            border-radius: 0.347vw;
          }
        }
        .notData_bar {
          width: calc(100% - 5.55vw);
          height: 0.694vw;
          background-color: var(--mixtmt_greyColor7);
          border-radius: 0.347vw;
        }
        .timeData_area {
          width: 5.55vw;
          text-align: right;
          font-size: 1.11vw;
          color: var(--mixtmt_greyColor3);
          font-weight: bold;
        }
      }
    }
  }
}
</style>
